import { render, staticRenderFns } from "./JobTeacher.vue?vue&type=template&id=68b32b97&scoped=true"
import script from "./JobTeacher.vue?vue&type=script&lang=js"
export * from "./JobTeacher.vue?vue&type=script&lang=js"
import style0 from "./JobTeacher.vue?vue&type=style&index=0&id=68b32b97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b32b97",
  null
  
)

export default component.exports